import { useI18n as vueUseI18n } from 'vue-i18n'
import { setLanguage as setGlobalLanguage } from '@/i18n'
import type { SupportedLocale } from '@/i18n'

const LANGUAGE_STORAGE_KEY = 'zoomcatalog-language'
const DEFAULT_LANGUAGE = 'en'

/**
 * Gets the current language from localStorage
 * @returns {string} Current language code (defaults to 'en')
 */
export function getCurrentLanguage(): string {
	return sessionStorage.getItem(LANGUAGE_STORAGE_KEY) || DEFAULT_LANGUAGE
}

/**
 * Composable for i18n functionality in Smart Layouts
 * Usage in components:
 * const { t, locale, setLanguage, getCurrentLanguage } = useI18n()
 */
export function useI18n() {
	const { t, locale } = vueUseI18n()

	const setLanguage = (lang: SupportedLocale) => {
		// Update local i18n
		setGlobalLanguage(lang)

		// Persist to sessionStorage
		sessionStorage.setItem(LANGUAGE_STORAGE_KEY, lang)

		// Also update design system language
		import('@zoomcatalog/shared')
			.then((shared: any) => {
				if (shared.setLanguage) {
					shared.setLanguage(lang)
				}
			})
			.catch(() => {
				// Silently fail if shared package doesn't have i18n
			})
	}

	return {
		t,
		locale,
		setLanguage,
		getCurrentLanguage,
	}
}
